import { Button } from '@headlessui/react'
import { ReactNode } from 'react'
import { DefaultLoader } from '../DefauilLoader/DefaultLoader'

type Props = {
  children?: ReactNode
  type?: 'button' | 'reset' | 'submit'
  variant?: 'primary' | 'outlined' | 'transparent' | 'ghost' | 'setting'
  size?: 'default' | 'icon'
  radius?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'
  padding?: 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'empty'
  className?: string
  disabled?: boolean
  isLoading?: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  icon?: ReactNode
  iconPosition?: 'left' | 'right'
  loader?: ReactNode
}

export const BaseButton = (props: Props) => {
  const {
    children,
    variant = 'primary',
    size = 'default',
    radius,
    padding = 'md',
    onClick,
    disabled,
    isLoading = false,
    className = '',
    type = 'button',
    icon,
    iconPosition = 'left',
    loader,
  } = props

  const baseClasses =
    'flex justify-center items-center gap-2 cursor-pointer duration-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2'

  const variantClasses =
    variant === 'primary'
      ? 'font-klein font-medium text-white bg-primary hover:bg-primary-hover disabled:bg-primary-disabled dark:bg-primary-dark dark:hover:bg-primary-dark-hover dark:disabled:bg-primary-dark-disabled border-0 ring-1 ring-primary dark:ring-primary-dark   hover:ring-primary-hover dark:hover:ring-primary-dark-hover disabled:ring-primary-disabled dark:disabled:ring-primary-dark-disabled disabled:cursor-not-allowed'
      : variant === 'outlined'
        ? 'font-klein font-medium ring-1 ring-inset ring-current text-primary dark:text-primary-dark hover:bg-light-purple dark:hover:bg-dark-purple'
        : variant === 'ghost'
          ? ''
          : variant === 'setting'
            ? 'border-0 ring-1 text-main-black dark:text-white ring-text-muted dark:ring-card-border-dark bg-light-purple dark:bg-dark-purple hover:bg-[#dcdcfc] dark:hover:bg-primary-dark-hover'
            : 'inline-flex justify-start bg-transparent'

  const radiusClasses = {
    none: '',
    sm: 'rounded-sm',
    md: 'rounded-md',
    lg: 'rounded-lg',
    xl: 'rounded-xl',
    '2xl': 'rounded-2xl font-klein font-medium',
    '3xl': 'rounded-3xl',
  }[radius || '2xl']

  const paddingClasses =
    size === 'icon'
      ? 'w-6 h-6 md:w-10 md:h-10 p-0'
      : {
          none: 'py-[8px]',
          xs: 'px-2 py-1',
          sm: 'px-[45px] py-[4px]',
          md: 'px-[45px] py-[8px]',
          lg: 'px-[45px] py-[12px]',
          empty: '',
        }[padding || 'md']

  const buttonClasses = `${baseClasses} ${variantClasses} ${radiusClasses} ${paddingClasses} ${className}`

  return (
    <Button
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled || isLoading}
      type={type}
    >
      {isLoading ? (
        loader || <DefaultLoader size={size} />
      ) : (
        <>
          {iconPosition === 'left' && icon && <span>{icon}</span>}
          {children}
          {iconPosition === 'right' && icon && <span>{icon}</span>}
        </>
      )}
    </Button>
  )
}
